export default function BackToTop() {
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-md bg-foreground-950 text-background-50 opacity-90 transition-opacity hover:opacity-100"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}